<template>
  <el-row>
    <el-row>
      <el-card>
        <div slot="header" class="clearfix">
          <span>ExamSysDiagram</span>
        </div>
        <div>
          <el-steps :active="0" simple>
            <el-step title="管理员" icon="el-icon-s-custom" />
            <el-step title="普通用户" icon="el-icon-user" />
          </el-steps>
          <el-steps :active="0" finish-status="success" simple style="margin-top: 20px">
            <el-step title="科目" icon="el-icon-s-grid" />
            <el-step title="试题" icon="el-icon-tickets" />
            <el-step title="试卷" icon="el-icon-notebook-2" />
            <el-step title="测评" icon="el-icon-notebook-2" />
          </el-steps>
          <el-steps :active="0" finish-status="success" simple style="margin-top: 20px">
            <el-step title="测评列表" icon="el-icon-files" />
            <el-step title="测评试卷" icon="el-icon-loading" />
            <el-step title="测评阅卷" icon="el-icon-edit" />
            <el-step title="测评结果" icon="el-icon-s-data" />
          </el-steps>
        </div>
      </el-card>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'ExamDashboard',
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    getData() {
    }
  }
}
</script>

<style scoped>
</style>
